// eslint-disable-next-line
import 'core-js/fn/array/from'
import { DirectiveOptions } from 'vue'

const wrapCalss:DirectiveOptions = {
  inserted(el, binding) {
    if (!binding.value) return

    const div = document.createElement('div')
    div.style.height = '0px'
    div.style.display = 'inline-block'
    div.style.whiteSpace = 'nowrap'
    div.style.overflow = 'hidden'
    div.innerHTML = el.innerHTML
    document.body.appendChild(div)

    if (div.clientWidth > el.clientWidth) {
      el.classList.add(binding.value)
    } else {
      el.classList.remove(binding.value)
    }
    document.body.removeChild(div)
  },
  componentUpdated(...args) {
    if (wrapCalss.inserted) {
      wrapCalss.inserted(...args)
    }
  }
}

export default wrapCalss
